import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const CategoryTiles = () => {
  const categories = [
    {
      id: 'ees-centers',
      name: 'EES Centers',
      description: 'Energy Enhancement Systems',
      icon: 'Zap',
      color: 'from-primary to-secondary', // Updated from blue
      hoverColor: 'hover:from-secondary hover:to-primary', // Updated from blue
      count: 342
    },
    {
      id: 'meditation',
      name: 'Meditation',
      description: 'Mindfulness & Inner Peace',
      icon: 'Heart',
      color: 'from-secondary to-accent', // Updated from purple
      hoverColor: 'hover:from-accent hover:to-secondary', // Updated from purple
      count: 589
    },
    {
      id: 'detox',
      name: 'Detox Programs',
      description: 'Cleanse & Purify',
      icon: 'Leaf',
      color: 'from-success to-success-500', // Updated from green
      hoverColor: 'hover:from-success-500 hover:to-success', // Updated from green
      count: 267
    },
    {
      id: 'yoga',
      name: 'Yoga Retreats',
      description: 'Body, Mind & Spirit',
      icon: 'Users',
      color: 'from-accent to-primary', // Updated from teal
      hoverColor: 'hover:from-primary hover:to-accent', // Updated from teal
      count: 423
    },
    {
      id: 'sound-healing',
      name: 'Sound Healing',
      description: 'Vibrational Medicine',
      icon: 'Headphones',
      color: 'from-warning to-warning-500', // Updated from orange
      hoverColor: 'hover:from-warning-500 hover:to-warning', // Updated from orange
      count: 189
    },
    {
      id: 'crystal-therapy',
      name: 'Crystal Therapy',
      description: 'Energy Alignment',
      icon: 'Gem',
      color: 'from-primary to-accent', // Updated from pink, using new palette colors
      hoverColor: 'hover:from-accent hover:to-primary', // Updated from pink
      count: 156
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const tileVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };

  return (
    <div className="mt-12">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-text-primary mb-2 font-heading">
          Explore Wellness Experiences
        </h3>
        <p className="text-text-secondary">
          Discover your perfect healing modality
        </p>
      </div>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 max-w-6xl mx-auto"
      >
        {categories.map((category) => (
          <motion.div key={category.id} variants={tileVariants}>
            <Link
              to={`/wellness-center-listings?category=${category.id}`}
              className="group block"
            >
              <div className="bg-white rounded-2xl p-6 shadow-elevation-1 hover:shadow-elevation-3
                               border border-border transition-all duration-300 ease-out text-center
                               hover:-translate-y-1">
                {/* Icon */}
                <div className="mb-4">
                  <div className={`w-16 h-16 mx-auto rounded-2xl bg-gradient-to-br ${category.color}
                                   ${category.hoverColor} flex items-center justify-center
                                   shadow-elevation-2 transition-all duration-300
                                   group-hover:scale-110`}>
                    <Icon name={category.icon} size={28} className="text-white" />
                  </div>
                </div>

                {/* Content */}
                <div>
                  <h4 className="text-lg font-bold text-text-primary mb-1 font-heading group-hover:text-primary transition-colors duration-200"> {/* Updated from blue-600 */}
                    {category.name}
                  </h4>
                  <p className="text-sm text-text-secondary mb-2 group-hover:text-text-primary transition-colors duration-200">
                    {category.description}
                  </p>
                  <div className="flex items-center justify-center space-x-1 text-xs
                                   text-text-secondary">
                    <span>{category.count}</span>
                    <span>centers</span>
                  </div>
                </div>

                {/* Hover Effect */}
                <div className="mt-4 opacity-0 group-hover:opacity-100 transition-opacity
                                 duration-200 transform translate-y-2 group-hover:translate-y-0">
                  <div className="flex items-center justify-center text-primary text-sm font-medium"> {/* Updated from blue-600 */}
                    <span>Explore</span>
                    <Icon name="ArrowRight" size={14} className="ml-1" />
                  </div>
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </motion.div>

      {/* Additional Quick Links */}
      <div className="text-center mt-8">
        <div className="flex flex-wrap justify-center gap-3">
          {[
            'Chakra Balancing',
            'Energy Healing',
            'Breathwork',
            'Sacred Ceremonies',
            'Holistic Massage',
            'Ayurvedic Healing'
          ].map((tag) => (
            <Link
              key={tag}
              to={`/wellness-center-listings?tag=${tag.toLowerCase().replace(' ', '-')}`}
              className="px-4 py-2 bg-white border border-border rounded-full text-sm
                         font-medium text-primary hover:bg-background-light hover:border-border-focus {/* Updated from blue-200, blue-700, blue-50, blue-300 */}
                         transition-all duration-200 shadow-elevation-1 hover:shadow-elevation-2"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryTiles;
